var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0345 12.2759H9.79311V14.7586H23.0345V12.2759Z",
    fill: "#00FF3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3793 17.2414H11.4483V19.7242H21.3793V17.2414Z",
    fill: "#00FF3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C22.6172 4 28 9.38315 28 16V28H16C9.38285 28 4 22.6168 4 16C4 9.38285 9.38315 4 16 4ZM16 25.6217H25.6156V16.0003C25.6156 10.6947 21.2995 6.38468 16 6.38468C10.7005 6.38468 6.38437 10.7008 6.38437 16.0003C6.38437 21.2998 10.6944 25.6217 16 25.6217Z",
    fill: "#00FF3C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/call-center.5d683e3335b9d0b528c7a8ed4c936db4.svg";
export { ForwardRef as ReactComponent };